import React, { Component } from "react";
import PropTypes from "prop-types";
import styles from "./Icon.module.css";

export default class Icon extends Component {
  render() {
    const { spin } = this.props;
    const className =
      "fa fa-" + this.props.icon + (spin ? " " + styles.spin : "");
    return <i className={className} aria-hidden="true" {...this.props}></i>;
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
};
